export default "__VITE_ASSET__CT24btMK__"